import { getApiUrl } from "@/shared/utils/api";

export const SENTRY_DSN: string = import.meta.env.VITE_SENTRY_DSN || "";

export const SENTRY_ENVIRONMENT: string =
  import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE;

export const SENTRY_RELEASE: string =
  import.meta.env.VITE_APP_VERSION || "unknown";

export const SENTRY_ENABLED_ENVIRONMENTS = ["testing", "production", "development"] as const;

export const SENTRY_SAMPLE_RATES = {
  TRACES: 1.0,
  REPLAYS_SESSION: 0.1,
  REPLAYS_ON_ERROR: 1.0,
} as const;

export const SENTRY_CONSOLE_LOG_LEVELS: Array<
  "log" | "error" | "warn" | "debug" | "info"
> = ["log", "error", "warn"];

// The alert rules filter on the absence of this tag: renaming or removing it silently re-enables alerts.
export const SENTRY_NOISE_TAG = "noise_category";

export const SENTRY_NOISE_CATEGORIES = {
  NETWORK: "network",
  CLIENT_ERROR: "client_error",
  ROUTE_NOT_FOUND: "route_not_found",
} as const;

export const SENTRY_NOISE_LEVEL = "warning";

export const SENTRY_ENDPOINT_TAG = "endpoint";

export const SENTRY_ROUTE_PATH_TAG = "route_path";

// react-router assigns this key to the first location of a session: no in-app navigation led there.
export const INITIAL_LOCATION_KEY = "default";

export const ROUTE_NOT_FOUND_MESSAGE_PREFIX = "Route not found: ";

export const BROKEN_IN_APP_LINK_MESSAGE_PREFIX = "Broken in-app link: ";

export const BROKEN_IN_APP_LINK_FINGERPRINT_KEY = "broken_in_app_link";

export const UNKNOWN_ENDPOINT = "unknown_endpoint";

export const UNKNOWN_METHOD = "UNKNOWN";

export const NETWORK_ERROR_CODES: readonly string[] = ["ERR_NETWORK", "ECONNABORTED", "ETIMEDOUT"];

export const HTTP_CLIENT_ERROR_MIN_STATUS = 400;

export const HTTP_SERVER_ERROR_MIN_STATUS = 500;

// Only used to let `URL` parse relative paths; never reported.
export const ENDPOINT_PLACEHOLDER_BASE = "http://endpoint.placeholder.invalid";

export const ENDPOINT_ID_PLACEHOLDER = ":id";

export const ENDPOINT_VERSION_SEGMENT = /^v\d+$/i;

export const ENDPOINT_ALL_DIGITS_SEGMENT = /^\d+$/;

export const ENDPOINT_UUID_SEGMENT = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// Case-sensitive on purpose: with /i, lowercase resource names such as `custom_attributes`
// or `card_reissuances` would be mistaken for hashids.
export const ENDPOINT_PREFIXED_HASHID_SEGMENT = /^[A-Z]+_[A-Z0-9]{10,}$/;

export const ENDPOINT_CONTAINS_DIGIT = /\d/;

// Catches lowercase hashids; the length floor spares short digit-bearing resource names like `2fa`.
export const ENDPOINT_OPAQUE_TOKEN_MIN_LENGTH = 6;

export const getSentryTracePropagationTargets = (): (string | RegExp)[] => {
  const apiBaseUrl = getApiUrl("");

  return [
    /^\//,
    ...(apiBaseUrl
      ? [new RegExp(`^${apiBaseUrl.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}`)]
      : []),
  ];
};

export const isSentryEnabled = (): boolean => {
  return (
    Boolean(SENTRY_DSN) &&
    SENTRY_ENABLED_ENVIRONMENTS.includes(
      SENTRY_ENVIRONMENT as (typeof SENTRY_ENABLED_ENVIRONMENTS)[number],
    )
  );
};
